import type { RiskLevel } from '@/types';
import { KimLhcCategoryKey } from '@/types';

export const RISK_LEVEL_COLORS: Record<RiskLevel, string> = {
	LOW: '#17A93B',
	SLIGHTLY_INCREASED: '#F2751C',
	SUBSTANTIALLY_INCREASED: '#D13342',
	HIGH: '#7828C8'
} as const;

export const RISK_LEVEL_LABEL_KEYS: Record<RiskLevel, string> = {
	LOW: 'Low risk',
	SLIGHTLY_INCREASED: 'Slightly elevated risk',
	SUBSTANTIALLY_INCREASED: 'Substantially elevated risk',
	HIGH: 'High risk'
} as const;

export interface CategoryScore {
	titleKey: string;
	scoreKey: string;
	maxScore: number;
	contentKey: KimLhcCategoryKey;
	hasGenderScores?: boolean;
	manScoreKey?: string;
	womanScoreKey?: string;
	manMaxScore?: number;
	womanMaxScore?: number;
}

export const CATEGORY_SCORES: CategoryScore[] = [
	{
		titleKey: 'Frequency',
		scoreKey: 'Frequency score',
		maxScore: 10,
		contentKey: KimLhcCategoryKey.FREQUENCY
	},
	{
		titleKey: 'Load weight',
		scoreKey: 'Weight score',
		maxScore: 4,
		contentKey: KimLhcCategoryKey.WEIGHT,
		hasGenderScores: true,
		manScoreKey: 'Men score',
		womanScoreKey: 'Women score',
		manMaxScore: 100,
		womanMaxScore: 100
	},
	{
		titleKey: 'Load handling conditions',
		scoreKey: 'Cargo handling condition score',
		maxScore: 4,
		contentKey: KimLhcCategoryKey.CARGO_HANDLING_CONDITION
	},
	{
		titleKey: 'Body posture',
		scoreKey: 'Body posture score',
		maxScore: 26,
		contentKey: KimLhcCategoryKey.POSTURE,
		hasGenderScores: true,
		manScoreKey: 'Men posture score',
		womanScoreKey: 'Women posture score',
		manMaxScore: 26,
		womanMaxScore: 26
	},
	{
		titleKey: 'Unfavorable work conditions',
		scoreKey: 'Work condition score',
		maxScore: 13,
		contentKey: KimLhcCategoryKey.WORK_CONDITION,
		hasGenderScores: true,
		manScoreKey: 'Men work condition score',
		womanScoreKey: 'Women work condition score',
		manMaxScore: 13,
		womanMaxScore: 13
	},
	{
		titleKey: 'Work organization',
		scoreKey: 'Work organization score',
		maxScore: 4,
		contentKey: KimLhcCategoryKey.WORK_ORGANIZATION,
		hasGenderScores: true,
		manScoreKey: 'Men work organization score',
		womanScoreKey: 'Women work organization score',
		manMaxScore: 4,
		womanMaxScore: 4
	}
];
